import { IPage, ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'
import { getBaseCiRequestUrl, getToken } from '@/utils/constants'
import { OrderDetailResult, OrderTotalResult, CustomerField } from './settleTypes'

class SettleService {

    async total(searchVo: any) {
        const apiUrl = '/yh-franchisee/order/platform_list_total'
        return await httpRequest.post<IPage<OrderTotalResult>>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    async detail(searchVo: any) {
        const apiUrl = '/yh-franchisee/order/platform_list'
        return await httpRequest.post<IPage<OrderDetailResult>>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    async one(id: string) {
        const apiUrl = `/yh-franchisee/investigationReport/select/${id}`
        return await httpRequest.get<any>(apiUrl)
    }

    async billInsert(params: any) {
        const apiUrl = '/yh-franchisee/franchiseeBill/insert'
        return await httpRequest.post<IPage<boolean>>(apiUrl, params, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    async statistics(searchVo: any) {
        const apiUrl = '/yh-franchisee/order/platform_list_statistics'
        return await httpRequest.post<CustomerField[]>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    async settlementAmount(searchVo: any) {
        const apiUrl = '/yh-franchisee/order/get_platform_list_settlementAmount'
        return await httpRequest.post<CustomerField[]>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

}

export const settleService = new SettleService()

